import { z } from 'zod';

export const EvaluateShortAnswerResponseSchema = z.object({
  feedback: z
    .string()
    .describe('Explanation for why the answer is correct or incorrect'),
  isCorrect: z.boolean().describe('Whether the user answer was deemed correct'),
});

export type IEvaluateShortAnswerResponseDto = z.infer<
  typeof EvaluateShortAnswerResponseSchema
>;
